import UnsupportedWidget from './UnsupportedWidget';

var registry = {};

export function registerWidget(type, component) {
  registry[type] = component;
}

export function getWidgetRenderer(type) {
  return registry[type] || UnsupportedWidget;
}

export function getWidgetRegistry() {
  return registry;
}
